<script lang="ts" setup>
	const headerConfig = {
		font: 'maitree-bold',
		size: 'md:text-[7.5em] xs:text-[3.75em] text-[3.5em]',
		color: 'text-blue-950 dark:text-gray-400',
		lineHeight: 'md:leading-[144px] sm:leading-[72px] leading-tight'
	}
	defineProps<{
		title?: string
		ui?: Partial<typeof headerConfig>
	}>()
	const cls = computed(() => useAttrs()?.class ?? '')
</script>

<template>
	<h2
		:class="
			cn(
				ui?.color ?? headerConfig.color,
				ui?.font ?? headerConfig.font,
				ui?.lineHeight ?? headerConfig.lineHeight,
				ui?.size ?? headerConfig.size,
				cls
			)
		"
	>
		<slot>
			<span v-html="title"></span>
		</slot>
	</h2>
</template>
